/**
 * EN translations
 * Flat key-value structure for simple lookup
 */
export default {
  __comment__: "English localization",
  page_title: "Veggiekarte - Find vegetarian and vegan places",
  texts_will_open_soon: ", but will open soon",
  texts_will_close_soon: ", but will close soon",
  texts_more_info: "More information",
  texts_content_welcome_heading: "Welcome",
  texts_content_welcome_text: "On veggiekarte.de you can find all vegan and vegetarian restaurants, ice cream parlors, cafés etc. registered in OpenStreetMap. Simply use the search field to search for your area or your street. All icons with a green background are venues with vegan options, while icons with a white background offer vegetarian but not vegan options.",
  texts_content_osm_heading: "About OpenStreetMap",
  texts_content_osm_text: "<a href='https://www.openstreetmap.org' target='_blank' rel='noopener noreferrer'>OpenStreetMap</a> is a free world map and works similarly to Wikipedia. Everyone can participate and enter information. This means that the map is full of useful information and updates continuously. Anyone who has suggestions for improvement or finds errors in the map can simply enter or fix data.",
  texts_content_contribute_heading: "Contribute information",
  texts_content_contribute_text: "If you yourself know restaurants, cafes, ice cream parlors or food kiosks that are not yet on the map, or run one yourself, then you can simply add them yourself. To do this, you have to mark the venue in OpenStreetMap with the 'diet:vegan' or 'diet:vegetarian' tag (\"Diet Types\"). Instructions are available <a href='how-to/tutorial_en.html' target='_blank' rel='noopener noreferrer'>here</a>.",
  texts_content_reviews_heading: "Reviews",
  texts_content_reviews_text: "<a href='https://lib.reviews/' target='_blank' rel='noopener noreferrer'>lib.reviews</a> is a free and open platform for reviewing anything. If there is a review of a place there, we will show a link to it.",
  texts_content_further_heading: "Further",
  texts_content_further_text: "Veggiekarte is updated automatically every hour. You can find the code on <a href='https://codeberg.org/piratenpanda/veggiekarte' target='_blank' rel='noopener noreferrer'>Codeberg</a>.",
  texts_i18n_vegan_only: "vegan only",
  texts_i18n_vegan_only_title: "Place which offers exclusively vegan food.",
  texts_i18n_vegetarian_only: "vegetarian and vegan only",
  texts_i18n_vegetarian_only_title: "Place which offers exclusively vegetarian and vegan food.",
  texts_i18n_vegan_friendly: "vegan friendly",
  texts_i18n_vegan_friendly_title: "Place which offers also vegan food.",
  texts_i18n_vegan_limited: "vegan limited",
  texts_i18n_vegan_limited_title: "Place with limited vegan offer (often you have to ask for it outside the menu).",
  texts_i18n_vegetarian_friendly: "vegetarian friendly",
  texts_i18n_vegetarian_friendly_title: "Place which offers also vegetarian food, but no vegan.",
  category_selection_title: "Selection",
  category_diet_types: "Diet Types",
  category_categories: "Categories",
  category_food_only: "Food Only",
  category_food_only_hint: "Show only food & drinks",
  category_show_all: "Show All",
  category_show_all_hint: "Show all categories",
  category_reset: "↺ Reset",
  category_reset_hint: "Reset to default settings",
  category_opening_hours: "Opening Hours",
  category_show_open_only: "Show open places only",
  category_show_open_only_hint: "Only show places that are currently open",
  category_show_open_only_zoom_hint: "Available from zoom level 13 (current: {zoom})",
  category_show_open_only_zoom_hint_active: "Active (zoom level {zoom})",
  opening_hours_control_active: "Show open places only (active)",
  opening_hours_control_inactive: "Show open places only",
  opening_hours_control_zoom_hint: "Show open places only (from zoom level {zoom})",
  category_food: "Food & Drinks",
  category_food_restaurant: "Restaurants",
  category_food_pizza: "Pizza",
  category_food_cafe: "Cafés",
  category_food_fast_food: "Fast Food",
  category_food_bar_pub: "Bars & Pubs",
  category_food_ice_cream: "Ice Cream",
  category_food_community_meals: "Community meals",
  category_food_bakery: "Bakeries & Pastries",
  category_shopping: "Shopping",
  category_shopping_supermarket: "Supermarkets",
  category_shopping_food_shop: "Food Shops",
  category_shopping_general: "General Shops",
  category_health_beauty: "Health & Beauty",
  category_health_beauty_hairdresser: "Hairdressers",
  category_health_beauty_pharmacy: "Pharmacies",
  category_health_beauty_spa: "Wellness & Spa",
  category_health_beauty_hospital: "Hospitals",
  category_accommodation: "Accommodation",
  category_accommodation_hotel: "Hotels & Guesthouses",
  category_accommodation_hut: "Huts",
  category_culture: "Culture",
  category_culture_entertainment: "Entertainment",
  category_culture_library: "Libraries",
  category_sports: "Sports & Recreation",
  category_sports_facilities: "Sports Facilities",
  category_education: "Education",
  category_education_school: "Schools & Universities",
  category_other: "Other",
  category_other_misc: "Miscellaneous",
  category_counter_total: "total",
  category_counter_visible: "visible",
  category_counter_viewport: "in viewport",
  words_loading: "Loading ...",
  words_close: "Close",
  wheelchair_yes: "Wheelchair accessible",
  wheelchair_no: "Not wheelchair accessible",
  wheelchair_limited: "Limited wheelchair accessibility",
  wheelchair_unknown: "Wheelchair accessibility unknown",
  words_open: "open",
  words_unknown: "unknown",
  words_closed: "closed",
  words_public_holiday: "holiday",
  words_review: "review",
  words_share: "Share",
  words_school_holidays: "school holidays",
  edit_modal_title: "Edit data",
  words_edit: "Edit",
  edit_modal_intro: "Help improve the data at OpenStreetMap. Your edits will benefit Veggiekarte and many other projects.",
  leaflet_L_control_fullscreen_fullscreen: "Fullscreen",
  leaflet_L_control_fullscreen_exitFullscreen: "Exit fullscreen",
  leaflet_L_control_geocoder_title: "Search",
  leaflet_L_control_geocoder_placeholder: "Search…",
  leaflet_L_control_geocoder_error_message: "Nothing found.",
  leaflet_L_control_infoButton_title: "Information about this site",
  leaflet_L_control_locate_where_am_i: "Show me where I am!",
  leaflet_L_control_locate_meter: "meters",
  leaflet_L_control_locate_distance: "You are within {distance} {unit} from this point.",
  leaflet_L_control_zoom_zoom_in: "Zoom in",
  leaflet_L_control_zoom_zoom_out: "Zoom out",
  leaflet_L_control_languageselector_title: "Select language",
  themes_light: "Light",
  themes_dark: "Dark",
  themes_grayscale: "Grayscale",
  themes_custom: "Custom",
  themeEditor_selectTheme: "Select Theme",
  themeEditor_customize: "Customize",
  themeEditor_back: "Back",
  themeEditor_resetToDefault: "Reset to Default",
  themeEditor_customizeTheme: "Customize this theme",
  themeEditor_customBadge: "Custom",
  themeEditor_controlStyle: "Control Style",
  themeEditor_lightControls: "Light",
  themeEditor_darkControls: "Dark",
  themeEditor_invert: "Invert",
  themeEditor_hueRotate: "Hue Rotate",
  themeEditor_saturate: "Saturate",
  themeEditor_brightness: "Brightness",
  themeEditor_contrast: "Contrast",
  themeEditor_sepia: "Sepia",
  themeEditor_grayscale: "Grayscale",
  themeEditor_themeButton: "Theme",
  texts_data_date: "Data as of",
  texts_check_updates: "Check for updates",
  texts_checking_updates: "Updating…",
  place_list_title: "Places in this view",
  place_list_count: "List of the {count} places in this view",
  place_list_zoom_in: "{count} places in this view – zoom in to see the list",
  place_list_empty: "No places in this view",
  sidebar_collapse: "Hide the list",
  sidebar_expand: "Show the list",
  sidebar_quick_filters: "Quick filters",
  sidebar_open_now: "Open now",
  sidebar_food: "Food",
  sidebar_shopping: "Shopping",
  sidebar_vegan_options: "Vegan",
  sidebar_vegan_options_hint: "Only places with vegan options",
  place_list_back: "Back to the list",
  info_back: "Back",
  filter_changes_one: "1 change from the default settings",
  filter_changes_other: "{count} changes from the default settings",
  filter_reset: "Reset",
  map_label: "Map",
  cluster_label: "{count} places",
  menu_title: "Menu",
  menu_statistics: "Statistics"
};
